import React, { Component, Suspense } from "react";
import { Redirect } from "react-router-dom";
import {
  AppFooter,
  AppHeader,
} from "@coreui/react";
import CommonStore from "../../stores/CommonStore";
import { inject, observer } from "mobx-react";

import DefaultHeader from "./DefaultHeader";
import DefaultPermissions from './DefaultPermissions';

const DefaultFooter = React.lazy(() => import('./DefaultFooter'));

class DefaultLayout extends Component {

  render() {
    if (!this.props.authStore.isAuthenticated) {
      CommonStore.showErrorMessage("Please login first");
      return <Redirect to="/login" />;
    };

    return (
      <div className="app">
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <AppHeader fixed>
          <DefaultHeader history={this.props.history} />
        </AppHeader>
        <DefaultPermissions location={this.props.location} prop={this.props} />

        {/* {this.props.location.pathname.split('/')[2] !== "kpi" && this.props.location.pathname.split('/')[2] !== "timetable" && this.props.location.pathname.split('/')[2] !== "chat"
          && this.props.location.pathname.split('/')[2] !== "chat-messages" && (
          <Suspense fallback={<div></div>}>
            <AppFooter>
              <DefaultFooter version={this.props.version} />
            </AppFooter>
          </Suspense>
        )} */}
        <Suspense fallback={<div></div>}>
          <AppFooter>
            <DefaultFooter version={this.props.version} />
          </AppFooter>
        </Suspense>
        {/* </Suspense> */}
      </div>
    );
  }
}

export default inject("authStore")(observer(DefaultLayout));
